import React, { useState } from "react";
import PropTypes from "prop-types";

const SidebarOption = ({ content, onClick, hover, selected }) => {
  const [isShown, setIsShown] = useState(false);

  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={() => setIsShown(true)}
      onMouseLeave={() => setIsShown(false)}
      className={`react__sidebar__buttons_container__option${
        selected ? " selected" : ""
      }`}
    >
      {content}
      {isShown && (
        <div className="react__sidebar__hover__hint">
          <div className="react__sidebar__hover__hint__triangle" />
          <p className="react__sidebar__hover__hint__paragraph">{hover}</p>
        </div>
      )}
    </button>
  );
};

export default SidebarOption;

SidebarOption.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  hover: PropTypes.string,
};

SidebarOption.defaultProps = {
  selected: false,
};
